import { GraphQLTypes, InputType, Selector } from '@zeus/index';
import { typedGql } from '@zeus/typedDocumentNode';
//import { scalars } from '~/gql/utils/scalars';

const soloTrackingSelector = Selector('SoloTracking')({
  id: true,
  position: true,
  trackedAnswers: {
    answerId: true,
    id: true,
    time: true,
  },
  isCompleted: true,
  userId: true,
});

export const GQL_CREATE_TRACKING = typedGql('mutation')({
  createTracking: {
    ...soloTrackingSelector,
  },
});

export type StoredSoloTracking = InputType<
  GraphQLTypes['SoloTracking'],
  typeof soloTrackingSelector
>;
